import { Pipe, PipeTransform } from '@angular/core';
import { CalibrationStatus } from '@models/record-status';

@Pipe({
  name: 'getRecordStatus'
})
export class GetRecordStatusPipe implements PipeTransform {
  transform(recordStatus: CalibrationStatus, ...args: any[]): string {
    switch (recordStatus) {
      case CalibrationStatus.Active:
        return 'Active';

      case CalibrationStatus.Proposed:
        return 'Proposed';

      case CalibrationStatus.Rejected:
        return 'Rejected';

      case CalibrationStatus.Inactive:
        return 'Inactive';

      default:
        return '&ndash;';
    }
  }
}
